import _Promise from 'babel-runtime/core-js/promise';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';

/* eslint-disable max-lines */
import _ from 'lodash';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import SearchBar from './search.vue';
import ItemList from './list.vue';
import ResUploader from './resUploader.vue';
import BatchUploader from './batch-uploader.vue';
import AddUpdateDialog from '../material/font/add-update-dialog.vue';
import { getItavMaterialList, getNonItavMaterialList } from '@/api/res_store/list';
import { fetchNonItavResTag } from '@/api/res_store/tag.js';
import { manageFontList } from '@/api/common/font';
import { createMaterial } from '@/api/res_store/create';
import { updateMaterialInfo } from '@/api/res_store/update';
import { deleteMaterial } from '@/api/res_store';
import { repositoryName, cat1Options, cat2Options, cat1OptionsParticle } from '@/views/repository/config';
var batchTypes = [6, 7, 8, 9, 10, 14, 15, 16, 17, 18];
export default {
  components: {
    Pagination: Pagination,
    SearchBar: SearchBar,
    ItemList: ItemList,
    AddUpdateDialog: AddUpdateDialog
  },

  mixins: [searchMixin],

  props: {
    canSelect: {
      type: Boolean,
      default: false
    },
    selectConfig: {
      type: Object,
      default: function _default() {
        return {
          type: 'checkbox',
          defaultList: [], // 默认选中值
          handleChange: function handleChange() {}
        };
      }
    },
    resourceType: {
      type: Number,
      default: 0,
      required: true
    },
    resourceClass: {
      type: Number,
      default: 1 // 1代表交互类型素材，2代表非交互类型素材
    },
    /**
     * 对search组件中的下拉选择项做过滤
     */
    optionsFilter: {
      type: Object,
      default: function _default() {}
    },
    /**
     * search默认传参
     */
    defaultQuery: {
      type: Object,
      default: function _default() {}
    },
    /**
     * 控制search组件的params
     */
    formItemParams: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      isEdit: false,
      pagination: {
        total: 0
      },
      query: {
        search_field: '',
        keyword: '',
        res_type: this.resourceType,
        tag_ids: [],
        cat1_ids: [],
        cat2_ids: [],
        access_allow_pt: '',
        page: 1,
        page_size: 15,
        order: '-updated_time'
      },
      fontDialog: {
        type: 'add',
        visible: false,
        current: ''
      },
      fontList: [],
      list: [],
      listLoading: true,
      isSlogan: this.resourceType === 12,
      isFont: this.resourceType === 19 // 字体
    };
  },
  created: function created() {
    this.renderList = _.debounce(this.renderList, 20);
    if (this.defaultQuery) {
      this.query = _Object$assign(this.query, this.defaultQuery);
    }
  },


  computed: {
    uploadComponentType: function uploadComponentType() {
      // 背景音乐6 手指库7 背景图库8 CTA按钮9 特效库10 对话框14 音效15 模板库16 进度条17 动画预设18
      // const batchResources = [6, 7, 8, 9, 10, 14, 15]
      if (batchTypes.includes(this.resourceType) && !this.isEdit) {
        return BatchUploader;
      }
      return ResUploader;
    },
    listType: function listType() {
      // 只有文案库使用table作为list
      if (this.isSlogan) return 'table';
      if (this.isFont) return 'font';
      return 'card';
    },
    formItems: function formItems() {
      // 字体库搜索项
      if (this.resourceType === 19) {
        return ['name', 'languages', 'tag_ids'];
      }

      var temp = ['search_field', // 搜索类型
      'keyword' // 关键字
      ];

      if (this.resourceType === 11) {
        temp = temp.concat(['cat1_ids']);
      }
      if (this.resourceType === 10) {
        temp = temp.concat(['cat1_ids']);
      }
      if (this.resourceType !== 12 && this.resourceType !== 16) {
        temp = temp.concat(['tag_ids']);
      }
      if (batchTypes.includes(this.resourceType)) {
        temp = temp.concat(['access_allow_pt']);
      }
      if (this.resourceType === 18) {
        temp = temp.filter(function (item) {
          return item !== 'tag_ids';
        });
      }
      return temp;
    },
    libName: function libName() {
      var _this = this;

      return (repositoryName.find(function (e) {
        return e.value === _this.resourceType;
      }) || {}).label;
    },
    keyField: function keyField() {
      var temp = [{
        value: 'id',
        label: this.libName + 'ID'
      }, {
        value: 'name',
        label: this.libName + (this.libName === '文案' ? '内容' : '名称')
      }];
      return temp;
    },
    innerList: function innerList() {
      var _this2 = this;

      var getDuration = function getDuration(extInfo) {
        var temp = '-';
        if (extInfo) {
          try {
            temp = JSON.parse(extInfo).duration;
          } catch (e) {
            throw new Error(e.message || 'JSON.parse 发生错误，接口返回数据不是合法的 JSON');
          }
        }
        return temp;
      };
      var getDimension = function getDimension(extInfo) {
        var temp = '-';
        if (extInfo) {
          try {
            temp = JSON.parse(extInfo).size;
          } catch (e) {
            throw new Error(e.message || 'JSON.parse 发生错误，接口返回数据不是合法的 JSON');
          }
        }
        return temp;
      };
      return this.list.map(function (item) {
        switch (_this2.resourceType) {
          case 5:
            item.file_type = 'video';
            break;
          case 6:
          case 15:
            item.file_type = 'audio';
            break;
          case 10:
            if (item.cat1_id === 1 || item.cat1_id === 3) {
              item.file_type = 'image';
            } else {
              item.file_type = 'sequence-frame';
            }
            break;
          case 11:
            if (item.cat1_id === 2) {
              item.file_type = 'sequence-frame';
            } else {
              item.file_type = 'image';
            }
            break;
          default:
            item.file_type = 'image';
            break;
        }
        var cat1OptionsItem = cat1OptionsParticle.find(function (e) {
          return e.value === item.cat1_id;
        });
        return _extends({}, item, {
          tag_ids: (item.tags || []).length ? item.tags.map(function (e) {
            return Number(e.id);
          }) : [],
          tag_names: (item.tags || []).length ? item.tags.map(function (e) {
            return e.name;
          }).join() : '',
          duration: getDuration(item.ext_info),
          dimension: item.file_dimension || getDimension(item.ext_info),
          cat1_name: _this2.resourceType !== 10 ? (cat1Options.find(function (e) {
            return e.value === item.cat1_id;
          }) || {}).label : cat1OptionsItem && cat1OptionsItem.label,
          cat2_name: _this2.resourceType !== 10 ? (cat2Options.find(function (e) {
            return e.value === item.cat2_id;
          }) || {}).label : ''
        });
      });
    },
    widthoutSearch: function widthoutSearch() {
      return this.isFont;
    }
  },

  watch: {
    $route: function $route(to, from) {
      !this.canSelect && this.renderList();
    }
  },

  methods: {
    showFontDialog: function showFontDialog(type, item) {
      if (type === 'add') {
        this.fontDialog.current = '';
      } else {
        this.fontDialog.current = item;
      }
      this.fontDialog.type = type;
      this.fontDialog.visible = true;
    },
    renderList: function renderList(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var postData, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.listLoading = true;
                _context.prev = 1;

                // 保证query为空的时候，也有res_type等值
                postData = params || _this3.query;

                if (!postData.res_type) {
                  postData.res_type = _this3.resourceType;
                }
                if (!postData.order) {
                  postData.order = '-updated_time';
                }
                if (!batchTypes.includes(_this3.resourceType)) {
                  delete postData.access_allow_pt;
                }
                res = void 0;
                _context.t0 = true;
                _context.next = _context.t0 === (_this3.resourceType === 19) ? 10 : _context.t0 === (_this3.resourceClass === 1) ? 14 : _context.t0 === (_this3.resourceClass === 2) ? 19 : 23;
                break;

              case 10:
                _context.next = 12;
                return manageFontList(postData);

              case 12:
                res = _context.sent;
                return _context.abrupt('break', 24);

              case 14:
                _context.next = 16;
                return getItavMaterialList(postData);

              case 16:
                res = _context.sent;

                console.log(res);
                return _context.abrupt('break', 24);

              case 19:
                _context.next = 21;
                return getNonItavMaterialList(postData);

              case 21:
                res = _context.sent;
                return _context.abrupt('break', 24);

              case 23:
                return _context.abrupt('break', 24);

              case 24:
                _this3.list = _.get(res, 'data.data.list') || [];
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context.next = 32;
                break;

              case 29:
                _context.prev = 29;
                _context.t1 = _context['catch'](1);

                _this3.listLoading = false;

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 29]]);
      }))();
    },
    specialHandleSearch: function specialHandleSearch(params) {
      if (this.canSelect) {
        this.renderList(params);
      } else {
        this.handleSearch(params);
      }
    },
    specialHandleResetSearch: function specialHandleResetSearch() {
      if (this.canSelect) {
        this.renderList(_Object$assign({
          res_type: this.resourceType,
          page: 1,
          page_size: 15,
          order: '-updated_time'
        }, this.defaultQuery));
      } else {
        this.handleResetSearch();
      }
    },
    specialHandleSizeChange: function specialHandleSizeChange(pageSize) {
      if (this.canSelect) {
        this.renderList(_Object$assign(this.query, {
          page: 1,
          page_size: pageSize
        }));
      } else {
        this.handleSizeChange(pageSize);
      }
    },
    specialHandleCurrentChange: function specialHandleCurrentChange(page) {
      if (this.canSelect) {
        this.renderList(_Object$assign(this.query, {
          page: page
        }));
      } else {
        this.handleCurrentChange(page);
      }
    },
    handleCreate: function handleCreate() {
      var _this4 = this;

      this.isEdit = false;
      setTimeout(function () {
        _this4.$refs.uploader.show();
      });
    },
    handleUpdate: function handleUpdate(item) {
      var _this5 = this;

      this.isEdit = true;
      setTimeout(function () {
        _this5.$refs.uploader.show({
          edit: true,
          value: item
        });
      });
    },
    createResource: function createResource(data) {
      var postKeys = ['res_type', 'name', 'file_type', 'file_path', 'tag_ids'];
      if (this.resourceType === 10) {
        postKeys = postKeys.concat(['cat1_id', 'cat2_id']);
      }
      if (this.resourceType === 11) {
        postKeys = postKeys.concat(['cat1_id']);
      }
      if (this.isSlogan) {
        postKeys = ['res_type', 'message'];
      }
      return createMaterial(_.pick(data, postKeys));
    },
    submitDialogForm: function submitDialogForm(data) {
      var _this6 = this;

      // 新建场景
      if (!this.$refs.uploader.editType) {
        var promiseArray = [];
        if (this.$refs.uploader.isBatch) {
          promiseArray.push(createMaterial({ batch: _JSON$stringify(data.params) }));
          _Promise.all(promiseArray).then(function (res) {
            res = res[0].data;
            var ret = res.data.result;
            var err = ret.filter(function (item) {
              return !item.success;
            });
            if (err.length === 0) {
              _this6.$message({
                message: '添加成功',
                type: 'success'
              });
              _this6.$refs.uploader.close();
              _this6.renderList();
            } else {
              err.forEach(function (item, index) {
                _this6.$refs.uploader.setErrorMessage({ index: index, errorMessage: item.error_message });
                setTimeout(function () {
                  _this6.$message({
                    message: item.error_message,
                    type: 'error'
                  });
                }, 0);
              });
            }
          }).finally(function () {
            _this6.$refs.uploader && (_this6.$refs.uploader.dialogConfig.loading = false);
          });
          return;
        }
        promiseArray.push(this.createResource(data));
        _Promise.all(promiseArray).then(function (res) {
          _this6.$message({
            message: '添加成功',
            type: 'success'
          });
          _this6.$refs.uploader.close();
          _this6.renderList();
        }).catch(function (res) {
          _this6.$refs.uploader.removeLoading();
        });
      } else {
        var postData = {
          queryId: data.id,
          tag_ids: Array.isArray(data.tag_ids) ? data.tag_ids.join() : data.tag_ids,
          name: data.name
        };
        if (batchTypes.includes(this.resourceType)) {
          postData.access_allow_pt = data.access_allow_pt;
        }
        if (this.resourceType === 14) {
          postData.ext_config = data.ext_config;
        }
        if (this.resourceType === 18) {
          postData.cat1_id = data.cat1_id;
          postData.cat2_id = data.cat2_id;
        }
        if (data.name_en) {
          postData.name_en = data.name_en;
        }
        updateMaterialInfo(postData).then(function (res) {
          // 先保存app信息，再提交整体策划案
          _this6.$message({
            message: '修改成功',
            type: 'success'
          });
          _this6.$refs.uploader.close();
          _this6.renderList();
        }).catch(function (res) {
          _this6.$refs.uploader.removeLoading();
        });
      }
    },
    handleDelete: function handleDelete(item) {
      var _this7 = this;

      deleteMaterial({
        id: item.id
      }).then(function (res) {
        // 先保存app信息，再提交整体策划案
        _this7.$message({
          message: '删除成功',
          type: 'success'
        });
        _this7.renderList();
      }).catch(function (res) {});
    },
    getFontList: function getFontList() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, fontTags;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchNonItavResTag();

              case 2:
                res = _context2.sent;
                fontTags = (_.get(res, 'data.data.tag.sub_tags') || []).find(function (item) {
                  return item.id === 19;
                }) || '';

                _this8.fontList = fontTags ? fontTags.sub_tags : [];

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    }
  },

  mounted: function mounted() {
    this.getFontList();
    this.renderList();
  }
};